import React, { useState } from 'react';

import { formatCurrency } from 'utils/formatCurrency';

import Favoritar from 'components/Favoritar';
import ImageWithFallback from 'components/ImageWithFallback';

import { AdImageNotFoundSVG } from '../../utils/icons';

import {
    Card,
    CardImageContainer,
    SuperDestaque,
    Destaque,
    FavoritoWrapper,
    Titulo,
    Subtitulo,
    Preco,
    TextContainer,
    InfoContainer,
} from './cardSimilares-styled';

const CardSimilares = ({ similaresId, ...item }) => {
    const formatUrl = (url) => {
        const newUrl = new URL(url);

        return newUrl.pathname;
    };

    const [fav] = useState();

    return (
        <>
            <Card>
                <CardImageContainer>
                    <ImageWithFallback
                        src={item.imagem}
                        alt={'imagem do imóvel'}
                        layout="fill"
                        objectFit="cover"
                        onHasError={() => {}}
                        fallbackSrc={AdImageNotFoundSVG}
                    />

                    <InfoContainer>
                        {validatePriority(item.prioridade)}

                        <FavoritoWrapper>
                            <Favoritar
                                idAnuncio={similaresId}
                                size={18}
                                favorito={fav}
                            />
                        </FavoritoWrapper>
                    </InfoContainer>
                </CardImageContainer>

                <a
                    href={formatUrl(item.url)}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <TextContainer>
                        <>
                            <Titulo>{item.titulo}</Titulo>

                            <Subtitulo>{item.localizacao}</Subtitulo>

                            {item.valorCombinar ? (
                                <Preco>a combinar</Preco>
                            ) : (
                                <Preco>{formatCurrency(item.valor)}</Preco>
                            )}
                        </>
                    </TextContainer>
                </a>
            </Card>
        </>
    );

    function validatePriority(priority) {
        switch (priority) {
            case 'ALTA':
                return <SuperDestaque>Super Destaque</SuperDestaque>;
            case 'MEDIA':
                return <Destaque>Destaque</Destaque>;
            default:
                return <></>;
        }
    }
};

export default CardSimilares;
